import { ToggleButton, ToggleButtonGroup } from '@mui/material';

interface IToggleGroupProps {
  toggleValue: unknown;
  toggles: { label: string; value: string }[];
  onToggle: (newToggle: unknown) => void;
}

export default function ToggleGroup({
  onToggle,
  toggleValue,
  toggles
}: IToggleGroupProps) {
  return (
    <ToggleButtonGroup
      size='small'
      color='primary'
      value={toggleValue}
      exclusive
      onChange={(_event, currKPI) => {
        if (currKPI === null) {
          return;
        }
        onToggle(currKPI);
      }}
    >
      {toggles.map((toggle) => (
        <ToggleButton sx={{ width: '100px' }} value={toggle.value}>
          {toggle.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
